import React from 'react';
import { Navigate } from 'react-router-dom';
import LoginPage from '../../features/auth/pages/LoginPage';

export const publicRoutes = [
  { path: '/', element: <Navigate to="/login" /> },
  { path: '/login', element: <LoginPage /> },
];
